var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.138 15.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d85a13;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.569,
    cy: 7.569,
    r: 7.569
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3.687,
    cy: 7.569,
    r: 1.456
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 7.569,
    cy: 7.569,
    r: 1.456
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.45,
    cy: 7.569,
    r: 1.456
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDots);
export default __webpack_public_path__ + "static/media/WhiteDots.b66a762a19b596fe0c7c6eb8dc3d85f1.svg";
export { ForwardRef as ReactComponent };